import { DropdownItem } from '@/common/components';

export const languageOptions: DropdownItem[] = [
  { id: 'en', label: 'English' },
  { id: 'es', label: 'Spanish' },
  { id: 'cmn', label: 'Chinese (Mandarin)' },
  { id: 'yue', label: 'Chinese (Cantonese)' },
  { id: 'fil', label: 'Tagalog' },
  { id: 'vi', label: 'Vietnamese' },
  { id: 'ar', label: 'Arabic' },
  { id: 'fr', label: 'French' },
  { id: 'ko', label: 'Korean' },
  { id: 'ru', label: 'Russian' },
  { id: 'pt', label: 'Portuguese' },
  { id: 'haitian creole', label: 'Haitian Creole' },
  { id: 'hi', label: 'Hindi' },
  { id: 'de', label: 'German' },
  { id: 'pl', label: 'Polish' },
  { id: 'it', label: 'Italian' },
  { id: 'yi', label: 'Yiddish' },
  { id: 'so', label: 'Somali' },
  { id: 'hmong', label: 'Hmong' },
];
